import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const PRACTICE_KEYS = [
  "Use_A_Nutrient_Balance_Calculator",
  "Consult_A_CCA_Qualified_Agronomist",
  "Follow_Provincial_Recommendations",
  "Use_Variable_Rate_Prescription_Maps",
];

function selectedPracticeCount(questionnaire = {}) {
  return ["N", "P"].reduce(
    (total, nutrient) =>
      total +
      PRACTICE_KEYS.filter((key) => Boolean(questionnaire?.[nutrient]?.[key])).length,
    0
  );
}

function SummaryRow({ label, value, valid }) {
  const Icon = valid ? CheckCircleOutlineIcon : ErrorOutlineIcon;
  return (
    <div className="grid grid-cols-[24px_minmax(0,1fr)_auto] items-center gap-2 border-b border-slate-100 py-3 last:border-b-0">
      <Icon className={valid ? "text-[#2f6f45]" : "text-amber-600"} fontSize="small" />
      <span className="text-sm font-semibold text-slate-700">{label}</span>
      <span className="text-sm text-slate-600">{value}</span>
    </div>
  );
}

export default function FourRCompleteStep({
  soilTestCount,
  applicationCount,
  soilTestsValid,
  applicationsValid,
  operationsQuestionnaire,
}) {
  const practiceCount = selectedPracticeCount(operationsQuestionnaire);

  return (
    <div className="max-w-[760px]">
      <h5 className="text-base font-bold text-slate-800">Review detailed fertilizer records</h5>
      <p className="mt-1 text-sm leading-6 text-slate-600">
        Confirm that the evidence and applications below describe this crop year. You can return to any tab before completing the assessment.
      </p>
      <div className="mt-3 border-y border-slate-200">
        <SummaryRow
          label="Soil evidence"
          value={`${soilTestCount} test${soilTestCount === 1 ? "" : "s"}`}
          valid={soilTestsValid}
        />
        <SummaryRow
          label="Product applications"
          value={`${applicationCount} application${applicationCount === 1 ? "" : "s"}`}
          valid={applicationsValid}
        />
        <SummaryRow
          label="Selected 4R practices"
          value={`${practiceCount} selection${practiceCount === 1 ? "" : "s"}`}
          valid
        />
      </div>
    </div>
  );
}
